// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSocialMediaFacebook_loader__1ejEc","root":"IconSocialMediaFacebook_root__2X9uo"};